app.run(function($rootScope, $state, messenger, $window, $timeout, $translate, userManager, $uibModalStack, $location, lodash, analyticsService, modulesService, $q) {

    $rootScope.previousState;
    $rootScope.previousStateSref;
    $rootScope.currentState;
    $rootScope.loadStartTime;
    $rootScope.analyticsService = analyticsService;
    var initializeSessionPromise = null;
    var pendingStateTransition = null;

    if(analyticsService.isAllowed()) {
        $rootScope.$on('analytics.pageLoaded', function(event, args) {
            $rootScope.analyticsService.trackEvent({
                pageLoadSpeed: args.time - $rootScope.loadStartTime
            });
        });
    }

    $rootScope.$on('$stateChangeSuccess', function(ev, to, toParams, from, fromParams) {
        $rootScope.previousState = from.name;
        $rootScope.previousStateParams = fromParams;
        $rootScope.previousStateSref = from.name + "(" + JSON.stringify(fromParams) + ")";
        $rootScope.previousStateHref = from.ncyBreadcrumbLink;
        $rootScope.currentState = to.name;
        $rootScope.skipDirtyCheck = false;

        messenger.clearAll();

        if ($rootScope.scrollToTop === true || ($rootScope.scrollToTop === null && to.scroll !== false)) {
            $window.scroll(0, 0);
        }

        $rootScope.scrollToTop = null;

        if(analyticsService.isAllowed()) {
            $timeout(function() {
                if ($rootScope.hasOwnProperty('analyticsService')) {
                    $rootScope.analyticsService.trackEvent();
                }
            }, 1000);
        }
    });

    // Compute the login destination without nesting it. When we bounce off the
    // login page again (e.g. clicking a bookmark while already on login), a
    // preventDefault'd transition leaves $location pointing back at the login
    // URL, which already carries a `destination`. Re-encoding that would wrap the
    // existing destination into an ever-growing string, so reuse it verbatim if
    // present. Mirrors the 401 interceptor (request-interceptor.js).
    var getLoginDestination = function() {
        var existing = /destination=([^&]*)/.exec($window.location.hash);
        return existing ? decodeURIComponent(existing[1]) : $location.url().encode();
    };

    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        if (error === 'NOT_AUTHENTICATED' && $state.current.name !== 'login.step1') {
            event.preventDefault();
            $state.go('login.step1', { destination: getLoginDestination() });
        } else {
            console.error(error);
        }
    });

    var onBeforeUnload = function(event, toState, toStateParams, fromState) {

        var dirtyForm = userManager.checkIsDirty();
        var submittedForm = userManager.checkIsFormSubmitted();

        //Trigger notification if dirty form detected and not a submission.
        if(dirtyForm && (!submittedForm || $rootScope.checkDirtySubmittedForms)) {
            var answer = confirm($translate.instant('NAVIGATION_CONFIRMATION'));
            if(!answer) {
                abortStateChange(event);

                return false;
            } else {
                $rootScope.forceDirtyConfirm = false; //If we navigate away from the page we need to reset this.
            }
        } else {
            $rootScope.forceDirtyConfirm = false;
        }

        // Ensure user and modules are loaded before proceeding
        const publicStates = ['login', 'login.step1', 'login.step2', 'login.sso-link-password', 'email', 'email.verification', 'redirect', 'set-password', 'account-unlock', 'root', 'root-empty'];

        if (typeof toState !== 'undefined' && !publicStates.includes(toState.name)) {
            if (!userManager.user || modulesService.enabled === undefined) {
                pendingStateTransition = {
                    name: toState.name,
                    params: toStateParams
                };

                if (pendingStateTransition.name &&
                    ['login.step1', 'auth0-processing'].includes(pendingStateTransition.name)) {
                    return;
                }

                // Capture the destination NOW, while $location still points at the
                // route the user asked for. event.preventDefault() below reverts
                // $location back to the current (login) URL, so reading it in the
                // async .catch would capture "/login" and lose the target route.
                var destination = getLoginDestination();

                event.preventDefault(); // this breaks SSO

                if (initializeSessionPromise) {
                    return;
                }

                var userPromise = userManager.user ? $q.when(userManager.user) : userManager.getUser();
                initializeSessionPromise = userPromise
                    .then(function() {
                        return modulesService.load();
                    })
                    .then(function() {
                        // Retry the state transition
                        // We do not return the promise here because if the transition is prevented (e.g. by module access check),
                        // the promise will be rejected, and we don't want that to trigger the catch block below which redirects to login.

                        // Clear the duplicate state change prevention array from app.config.js
                        // forcing the retry to be treated as a new unique request
                        $rootScope.preventDuplicateStateChangeTo = [];

                        if (!pendingStateTransition || !pendingStateTransition.name) {
                            return;
                        }

                        var pendingName = pendingStateTransition.name;
                        var pendingParams = pendingStateTransition.params;

                        $timeout(function() {
                            $state.go(pendingName, pendingParams).catch(function (error) {
                                // transition prevented or superseded
                            });
                        }, 0);
                    })
                    .catch(function (error) {
                        $state.go('login.step1', { destination: destination });
                    })
                    .finally(function() {
                        initializeSessionPromise = null;
                        pendingStateTransition = null;
                    });
                return;
            }
        }

        // If the state has a permission variable, check the user has at least one of the specified permissions
        if (typeof toState !== 'undefined' && lodash.has(toState, 'data.permissions')) {
            checkAccess(event, toState.data.permissions);
        }

        // If the state has a modules variable, check the required modules are enabled
        // This also checks parent states for module requirements
        if (typeof toState !== 'undefined') {
            var allModules = getInheritedModules(toState);
            if (allModules.length > 0) {
                if (userManager.user && modulesService.enabled !== undefined) {
                    var blocked = checkModuleAccess(event, allModules);
                    if (blocked) {
                        return; // Halt execution if blocked
                    }
                }
            }
        }

        checkUserNeedsAcceptTermsOfUse(event, toState, fromState, publicStates);

        if (
            typeof toState !== 'undefined' &&
            toState.name !== 'dashboard.user.dashboard' &&
            $rootScope.feedbackRequired
        ) {
            event.preventDefault();

            return $state.go('dashboard.user.dashboard', {}, {reload: true});
        }
    };

    /**
     * @param  StateChangeEvent event
     * @param  array permissions
     */
    const checkAccess = function(event, permissions) {
        // Check the user has permission to access this page
        var hasPermission = false;

        angular.forEach(permissions, function (permission) {
            if (!hasPermission && userManager.hasPermission(permission)) {
                hasPermission = true;
            }
        });

        // Cancel the state change if permission is not granted
        if (!hasPermission) {
            abortStateChange(event);

            return $state.go('dashboard.user.dashboard', {}, {reload: true});
        }
    };

    const checkModuleAccess = function(event, modules) {
        // Check that ALL required modules are enabled; collect all disabled ones
        var disabledModules = modules.filter(function(module) {
            return !modulesService.isEnabled(module);
        });

        // Cancel the state change if any required module is not enabled
        if (disabledModules.length > 0) {
            abortStateChange(event);

            var moduleNames = disabledModules.map(function(m) { return lodash.startCase(m); }).join(', ');
            var translationKey = disabledModules.length === 1 ? 'MODULE_NOT_ENABLED' : 'MODULES_NOT_ENABLED';
            var translationParams = disabledModules.length === 1 ? {module: moduleNames} : {modules: moduleNames};
            $state.go('dashboard.user.dashboard', {}, {reload: true}).then(function() {
                messenger.error(translationKey, translationParams);
            });
            return true; // indicates user was blocked
        }
        return false;
    };

    const checkUserNeedsAcceptTermsOfUse = function(event, toState, fromState, publicStates) {
        if (
            userManager.user &&
            typeof toState !== 'undefined' &&
            ![...publicStates, 'dashboard.terms-of-use'].includes(toState.name) &&
            userManager.userNeedsAcceptTermsOfUse()
        ) {
            if (fromState.name !== 'dashboard.terms-of-use') {
                event.preventDefault();
                return $state.go('dashboard.terms-of-use');
            } else {
                return;
            }
        }
    }

    const getInheritedModules = function(state) {
        var modules = [];
        // Traverse up the state hierarchy, collecting modules from each level
        while (state) {
            if (state.data && state.data.modules) {
                // Prepend so ancestor modules come first (checked before descendant modules)
                modules = state.data.modules.concat(modules);
            }
            // Move to parent state
            if (state.parent) {
                // Explicit parent defined
                state = $state.get(state.parent);
            } else if (state.name && state.name.indexOf('.') > -1) {
                // Implicit parent via dot notation (e.g. "parent.child")
                var parentName = state.name.substring(0, state.name.lastIndexOf('.'));
                state = $state.get(parentName);
            } else {
                // No parent
                state = null;
            }
        }

        // Deduplicate while preserving ancestor-first order
        return modules.filter(function(module, index) {
            return modules.indexOf(module) === index;
        });
    };

    $rootScope.$on('$stateChangeStart', onBeforeUnload);
    $window.onbeforeunload = onBeforeUnload;

    var checkSessionExists = function(event) {
        if(event.key === 'token' || event.key === 'credentials') {
            if(!event.newValue) {
                $uibModalStack.dismissAll();
                $state.go('login.step1');
            }
        }
    };

    window.addEventListener('storage', checkSessionExists);

    function abortStateChange(event) {
        event.preventDefault();

        $timeout(function() {
            $rootScope.$broadcast('$stateChangeAborted');
        }, 0);
    }
});


app.config(function($provide) {
    $provide.decorator('$state', function($delegate, $rootScope) {
        var navigatingTo = null;

        // Rework $state.go to allow a new parameter
        $delegate.baseGo = $delegate.go;

        var go = function (to, params, options, scroll) {
            if (typeof scroll === 'boolean') {
                $rootScope.scrollToTop = scroll;
            }

            if (navigatingTo && navigatingTo.name !== to) {
                $rootScope.$broadcast('$stateChangeAborted', [navigatingTo, params]);
            }

            return this.baseGo(to, params, options);
        };

        $delegate.go = go;

        // Set variables on state change
        $rootScope.$on('$stateChangeStart', function(event, state, params) {
            $delegate.next = state;
            $delegate.toParams = params;
            $rootScope.loadStartTime = $rootScope.analyticsService.getTime();

            navigatingTo = state;
        });

        var clearNavigateTo = function() {
            navigatingTo = null;
        };

        $rootScope.$on('$stateChangeSuccess', clearNavigateTo);
        $rootScope.$on('$stateChangeAborted', clearNavigateTo);
        $rootScope.$on('$stateChangeError', clearNavigateTo);

        return $delegate;
    });
});
